import React from 'react';
import PropTypes from 'prop-types';

import Grid from '~/components/core/Atomic/Grid/Grid';
import CollapsibleWrapper from '~/components/core/Collapsible/CollapsibleWrapper';

import CardDialog from '../../../../CardDialog';
import HiddenIndication from '../HiddenIndication/HiddenIndication';

// Types only — no runtime effect. `actions = undefined` below makes TypeScript infer the prop as
// `undefined`, so a .tsx caller cannot pass the node PropTypes already allows. This restates the
// existing contract for those callers; the JS behaviour is unchanged.
/** @param {{ actions?: import('react').ReactNode, [key: string]: any }} props */
const BaseConfigurationSection = ({
  title,
  subtitle,
  isHidden = false,
  children,
  noGridContainer = false,
  disabled = false,
  actions = undefined,
  isSection = false,
  hideActionsOnCollapse = false,
  isCollapsible = true,
  // A full-width actions container declares `width: 100%` beside a title column that declares the
  // same, so the two split the header in half and the `Key:` subtitle wraps at the midpoint with the
  // right half sitting empty. Every section here renders content-sized actions (an indication chip
  // or an icon button) that `justify-content: flex-end` already right-aligns, so hugging them costs
  // nothing and gives the key the rest of the header.
  withActionsContainerFullWidth = false,
  disabledWithoutPadding = false,
  disabledWithoutChevron = false,
}) => {
  return (
    <CollapsibleWrapper
      title={title}
      subtitle={subtitle}
      backgroundColor={CollapsibleWrapper.BACKGROUND_COLOR.WHITE}
      actionCard
      noBorderLine
      noDivider
      defaultState={false}
      actions={actions ? actions : <HiddenIndication isActive={!isHidden} />}
      disabled={disabled}
      isCardShadow={isSection}
      hideActionsOnCollapse={hideActionsOnCollapse}
      isCollapsible={isCollapsible}
      withActionsContainerFullWidth={withActionsContainerFullWidth}
      disabledWithoutPadding={disabledWithoutPadding}
      disabledWithoutChevron={disabledWithoutChevron}
    >
      <CardDialog noCardTitle dontTrack>
        {noGridContainer ? (
          <>{children}</>
        ) : (
          <Grid container spacing={3}>
            {children}
          </Grid>
        )}
      </CardDialog>
    </CollapsibleWrapper>
  );
};
BaseConfigurationSection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isHidden: PropTypes.bool,
  children: PropTypes.node,
  noGridContainer: PropTypes.bool,
  disabled: PropTypes.bool,
  actions: PropTypes.node,
  isSection: PropTypes.bool,
  hideActionsOnCollapse: PropTypes.bool,
  isCollapsible: PropTypes.bool,
  withActionsContainerFullWidth: PropTypes.bool,
  disabledWithoutPadding: PropTypes.bool,
  disabledWithoutChevron: PropTypes.bool,
};

export default BaseConfigurationSection;
